module.exports = __webpack_public_path__ + "static/media/scott-gay-resume-04052024.8dfa81cb.pdf";